import { Link } from "react-router-dom";
import SubscribeForm from "@/components/feature/SubscribeForm";
import { siteInfo } from "@/mocks/site";

export default function SubscribeCta() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-shell mx-auto px-4 md:px-6">
        <div className="rounded-lg bg-foreground-950 text-background-100 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-12">
            <div className="lg:col-span-7 p-8 md:p-12">
              <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-accent-400 uppercase">
                <span className="w-6 h-px bg-accent-500" />
                Newsletter
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
                订阅爆料提醒，第一时间收到时间线更新
              </h2>
              <p className="mt-3 max-w-xl text-sm md:text-base leading-relaxed text-background-300/85">
                当你在意的事件出现新节点（尤其是反转与后续）时，我们会把更新摘要发到你的邮箱。不推销、不刷屏，只发进展。
              </p>
              <div className="mt-7 max-w-2xl">
                <SubscribeForm />
              </div>
            </div>
            <div className="lg:col-span-5 p-8 md:p-12 bg-foreground-900 border-t lg:border-t-0 lg:border-l border-foreground-800/70 flex flex-col gap-6">
              <div className="flex items-start gap-3">
                <span className="w-9 h-9 rounded-md bg-foreground-800 text-accent-400 flex items-center justify-center shrink-0">
                  <i className="ri-shield-check-line" />
                </span>
                <div>
                  <p className="text-sm font-medium text-background-50">只用于更新提醒</p>
                  <p className="mt-1 text-xs leading-relaxed text-background-400">
                    邮箱仅用于发送你订阅方向的进展摘要，随时可在邮件底部退订。
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-9 h-9 rounded-md bg-foreground-800 text-accent-400 flex items-center justify-center shrink-0">
                  <i className="ri-time-line" />
                </span>
                <div>
                  <p className="text-sm font-medium text-background-50">每日最多一封</p>
                  <p className="mt-1 text-xs leading-relaxed text-background-400">
                    没有新节点就不打扰。重大反转会单独发出，标注发生时间与来源。
                  </p>
                </div>
              </div>
              <div className="mt-auto pt-5 border-t border-foreground-800/70">
                <p className="text-xs text-background-400">也可以直接投递线索：</p>
                <Link
                  to="/about"
                  className="mt-2 inline-flex items-center gap-1.5 text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  <i className="ri-send-plane-line" />
                  进入线索投递
                </Link>
                <p className="mt-3 text-xs text-background-400">{siteInfo.contactEmail}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}